<div id="main-container" class="col-md-4 gradientBg">
  <h1>{{ mainTitle }}</h1>
</div>
<div id="questionLists" class="col-md-10 mt-5">
  <h2>Address:</h2>
  <p>
    1510 J Street, Suite 210
    <br />
    Sacramento, CA 95814
  </p>
  <p>
    <strong>Phone:</strong>
    (916) 444-2221
    <br />
    <strong>Fax:</strong>
    (916) 669-2870
  </p>

  <p>
    <strong>Email:</strong>
    <a class="ApplyClass" href="mailto:info@cahcc.com?subject=INFO - Website">
      info&#64;cahcc.com
    </a>
  </p>
</div>
